const VERSION = '0.1.0-browser-proof.1';

export const TEST_DEFINITIONS = [
  {
    id: 'demo-visual-inspection', version: VERSION, mode: 'simulation', category: 'Manual inspection', runner: 'manual',
    label: 'Visual inspection example', description: 'Try recording three example observations. No real product is inspected or updated.',
    requiredCapabilities: ['simulation.operator-input'],
    inputs: [
      { key: 'enclosure', label: 'Example enclosure is undamaged', type: 'boolean', default: false },
      { key: 'label', label: 'Example label is legible', type: 'boolean', default: false },
      { key: 'connector', label: 'Example connector is seated', type: 'boolean', default: false },
    ],
  },
  {
    id: 'demo-voltage-measurement', version: VERSION, mode: 'simulation', category: 'Numeric measurement', runner: 'numeric-range',
    label: 'Voltage measurement example', description: 'Enter a synthetic voltage and evaluate example limits. This does not read a meter.',
    requiredCapabilities: ['simulation.numeric-input'],
    inputs: [{ key: 'voltage', label: 'Synthetic voltage', type: 'number', default: 3.3, unit: 'V', min: 0, max: 60 }],
    acceptance: { key: 'voltage', min: 3.0, max: 3.6 },
  },
  {
    id: 'demo-optical-calculation', version: VERSION, mode: 'simulation', category: 'Calibration calculations', runner: 'northstar-reference',
    label: 'Optical calculation reference', description: 'Calculate a complete RGB lookup table from a synthetic ramp, then compare it with the Python reference.',
    requiredCapabilities: ['computation.northstar-maths'],
    inputs: [{ key: 'repeatCount', label: 'Calculation repetitions', type: 'number', default: 1, min: 1, max: 25, integer: true }],
    referenceCase: 'lut-linear-gamma22',
  },
];

for (const definition of TEST_DEFINITIONS) {
  for (const input of definition.inputs) Object.freeze(input);
  Object.freeze(definition.inputs); Object.freeze(definition.requiredCapabilities);
  if (definition.acceptance) Object.freeze(definition.acceptance);
  Object.freeze(definition);
}
Object.freeze(TEST_DEFINITIONS);
export const DEFAULT_TEST_ID = 'demo-optical-calculation';
export const getDefinition = id => TEST_DEFINITIONS.find(definition => definition.id === id) || null;
